import { Component, Vue } from 'vue-property-decorator'
import { baseSearch } from '@/api'
import Header from '@/components/componentWap/Header.vue'
@Component({
    name: 'SearchResult',
    components: {
        Header
    }
})
export default class extends Vue {
    private editData = {}
    private keyWord = this.$route.query.keyWord as string || ''
    private allVideo = `/helpCenter/${this.$route.params.ntwId}/allVideo?keyWord=${this.keyWord}`
    private allDoc = `/helpCenter/${this.$route.params.ntwId}/allDocument?keyWord=${this.keyWord}`
    private async getBaseSearch() {
        let res = await baseSearch(this.keyWord)
        res.data.videoList = res.data.videoList && res.data.videoList.slice(0, 4)
        res.data.docList = res.data.docList && res.data.docList.slice(0, 3)
        this.editData = res.data
    }
    private goVideoDetail(id: string) {
        this.$jump(`/Video/VideoDetail?videoId=${id}`)
    }
    private goDocDetail(id: string) {
        this.$jump(`/Question/QuestionDetail?questionId=${id}`)
    }
    created() {
        this.getBaseSearch()
    }
}